import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "hidden lg:block overflow-x-auto max-h-[600px] overflow-y-auto" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 sticky top-0 z-10" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = ["d"]
const _hoisted_7 = { class: "bg-white divide-y divide-slate-100" }
const _hoisted_8 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_9 = { class: "font-semibold text-slate-900" }
const _hoisted_10 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_11 = { class: "font-semibold text-slate-900" }
const _hoisted_12 = { class: "px-6 py-5" }
const _hoisted_13 = { class: "text-sm text-slate-600 max-w-md line-clamp-2" }
const _hoisted_14 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_16 = { class: "flex items-center gap-2 text-sm text-slate-600" }
const _hoisted_17 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_18 = { class: "flex gap-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "mt-5 lg:hidden space-y-4 max-h-[600px] overflow-y-auto px-4" }
const _hoisted_22 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 px-4 py-3 border-b border-slate-200" }
const _hoisted_23 = { class: "flex items-start justify-between gap-3" }
const _hoisted_24 = { class: "flex items-start justify-between gap-3" }
const _hoisted_25 = { class: "flex-shrink-0 w-8 h-8 flex items-center justify-center bg-slate-200 rounded-full font-bold text-slate-700 text-sm" }
const _hoisted_26 = { class: "flex-1 min-w-0" }
const _hoisted_27 = { class: "font-bold text-slate-900 text-base truncate" }
const _hoisted_28 = { class: "text-xs text-slate-500 mt-1 flex items-center gap-1" }
const _hoisted_29 = { class: "px-4 py-3 space-y-3" }
const _hoisted_30 = { class: "text-sm text-slate-700 mt-1 line-clamp-3" }
const _hoisted_31 = { class: "flex items-center justify-between py-2 px-3 bg-slate-50 rounded-lg" }
const _hoisted_32 = { class: "flex gap-2 pt-2" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "fixed bg-black bg-opacity-50 backdrop-blur-sm inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_36 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_37 = { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all w-full max-w-lg" }
const _hoisted_38 = { class: "px-6 py-4" }
const _hoisted_39 = { class: "text-sm text-slate-600 text-center mb-4" }
const _hoisted_40 = { class: "font-semibold text-slate-900" }
const _hoisted_41 = { class: "flex w-full flex-col-reverse sm:flex-row gap-3" }
const _hoisted_42 = { class: "flex-1 min-w-0" }
const _hoisted_43 = { class: "flex-1 min-w-0" }

import { ref, watch } from "vue";
import AdminToggleSwitch from "@/share/components/admin/AdminToggleSwitch.vue";
import AdminModalFooter from "@/share/components/admin/AdminModalFooter.vue";
import AdminButton from "@/share/components/admin/AdminButton.vue";
import type { Categoria } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";

interface Props {
  categorias: Categoria[];
  sortField: string | null;
  sortDirection: "asc" | "desc";
  isDelete?: boolean;
  currentPage?: number;
  pageSize?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriaTable',
  props: {
    categorias: {},
    sortField: {},
    sortDirection: {},
    isDelete: { type: Boolean },
    currentPage: { default: 1 },
    pageSize: { default: 10 }
  },
  emits: ["sort", "toggleVisibility", "editCategoria", "deleteCategoria"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showDeleteModal = ref(false);
const categoriaToDelete = ref<{ id: string; nombre: string } | null>(null);
const isDeleting = ref(false);

// Calcular el índice base según la página actual
const getGlobalIndex = (localIndex: number) => {
  return (props.currentPage - 1) * props.pageSize + localIndex + 1;
};

const getSortIcon = (field: string) => {
  if (props.sortField !== field) {
    return "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4";
  }
  return props.sortDirection === "asc"
    ? "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
    : "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4";
};

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const formatDateFull = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getVisibilidadText = (isVisible: number) => {
  return isVisible === 1 ? "Visible" : "Oculto";
};

const toggleVisibility = async (categoriaId: string) => {
  const categoria = props.categorias.find((c) => c.id === categoriaId);
  if (!categoria) return;
  categoria.isVisible = categoria.isVisible === 1 ? 0 : 1;
  await new Promise((resolve) => setTimeout(resolve, 150));
  emit("toggleVisibility", categoriaId);
};

const openDeleteModal = (categoriaId: string, nombre: string) => {
  categoriaToDelete.value = { id: categoriaId, nombre };
  showDeleteModal.value = true;
};

const closeDeleteModal = () => {
  showDeleteModal.value = false;
  categoriaToDelete.value = null;
};

const confirmDelete = () => {
  if (!categoriaToDelete.value || isDeleting.value) return;
  isDeleting.value = true;
  emit("deleteCategoria", categoriaToDelete.value.id);
};

const editCategoria = (categoriaId: string) => {
  emit("editCategoria", categoriaId);
};
watch(
  () => props.isDelete,
  (newVal) => {
    if (newVal) {
      showDeleteModal.value = false;
      categoriaToDelete.value = null;
      isDeleting.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xl font-bold text-slate-800 uppercase tracking-wider" }, " # ", -1)),
            _createElementVNode("th", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sort', 'nombreCategoria'))),
              class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider cursor-pointer hover:bg-slate-200 transition-colors group"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Categoría", -1)),
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["w-4 h-4 text-slate-400 group-hover:text-slate-600", {
                    'text-blue-600': props.sortField === 'nombreCategoria',
                  }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: getSortIcon('nombreCategoria')
                  }, null, 8, _hoisted_6)
                ], 2))
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider" }, " Descripción ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider" }, " Visibilidad ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider" }, " Fecha Creación ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider" }, " Acciones ", -1))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categorias, (categoria, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: categoria.id,
              class: "hover:bg-slate-50 transition-all duration-200 group"
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(getGlobalIndex(index)), 1)
              ]),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(categoria.nombreCategoria), 1)
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(categoria.descripcionCategoria || "Sin descripción"), 1)
              ]),
              _createElementVNode("td", _hoisted_14, [
                _createVNode(AdminToggleSwitch, {
                  "model-value": categoria.isVisible === 1,
                  color: "red",
                  "show-state-text": "",
                  "label-position": "left",
                  "switch-id": 'cat-vis-desktop-' + categoria.id,
                  onToggle: ($event: any) => (toggleVisibility(categoria.id))
                }, null, 8, ["model-value", "switch-id", "onToggle"])
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[7] || (_cache[7] = _createElementVNode("svg", {
                    class: "w-4 h-4 text-slate-400",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(formatDateFull(categoria.createdAt)), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (editCategoria(categoria.id)),
                    class: "p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors",
                    title: "Editar"
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      })
                    ], -1)
                  ]))], 8, _hoisted_19),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (
                    openDeleteModal(categoria.id, categoria.nombreCategoria)
                  ),
                    class: "p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors",
                    title: "Eliminar"
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      })
                    ], -1)
                  ]))], 8, _hoisted_20)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categorias, (categoria, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: categoria.id,
          class: "bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition-shadow"
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(getGlobalIndex(index)), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h3", _hoisted_27, _toDisplayString(categoria.nombreCategoria), 1),
                  _createElementVNode("p", _hoisted_28, [
                    _cache[10] || (_cache[10] = _createElementVNode("svg", {
                      class: "w-3 h-3",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(formatDate(categoria.createdAt)), 1)
                  ])
                ]),
                _createVNode(AdminToggleSwitch, {
                  "model-value": categoria.isVisible === 1,
                  color: "red",
                  "switch-id": 'cat-vis-mobile-' + categoria.id,
                  onToggle: ($event: any) => (toggleVisibility(categoria.id))
                }, null, 8, ["model-value", "switch-id", "onToggle"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-xs font-semibold text-slate-500 uppercase tracking-wide" }, "Descripción", -1)),
              _createElementVNode("p", _hoisted_30, _toDisplayString(categoria.descripcionCategoria || "Sin descripción"), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase" }, "Estado", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium", 
                categoria.isVisible === 1
                  ? 'bg-red-100 text-red-700'
                  : 'bg-gray-100 text-gray-700'
              ])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["w-1.5 h-1.5 rounded-full", 
                  categoria.isVisible === 1 ? 'bg-red-600' : 'bg-slate-500'
                ])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(getVisibilidadText(categoria.isVisible)), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                onClick: ($event: any) => (editCategoria(categoria.id)),
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium text-sm"
              }, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  })
                ], -1),
                _createTextVNode(" Editar ", -1)
              ]))], 8, _hoisted_33),
              _createElementVNode("button", {
                onClick: ($event: any) => (openDeleteModal(categoria.id, categoria.nombreCategoria)),
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-red-50 text-red-700 rounded-lg hover:bg-red-100 transition-colors font-medium text-sm"
              }, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  })
                ], -1),
                _createTextVNode(" Eliminar ", -1)
              ]))], 8, _hoisted_34)
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (showDeleteModal.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity",
                onClick: closeDeleteModal
              }),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "bg-gradient-to-br from-red-50 to-rose-50 px-6 pt-6 pb-4" }, [
                    _createElementVNode("div", { class: "flex items-center justify-center w-16 h-16 mx-auto bg-red-100 rounded-full" }, [
                      _createElementVNode("svg", {
                        class: "w-8 h-8 text-red-600",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        })
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[16] || (_cache[16] = _createElementVNode("h3", {
                      class: "text-xl font-bold text-slate-900 text-center mb-2",
                      id: "modal-title"
                    }, " ¿Eliminar categoría? ", -1)),
                    _createElementVNode("p", _hoisted_39, [
                      _cache[15] || (_cache[15] = _createTextVNode(" Estás a punto de eliminar la categoría ", -1)),
                      _createElementVNode("span", _hoisted_40, " \"" + _toDisplayString(categoriaToDelete.value?.nombre) + "\" ", 1)
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "bg-amber-50 border-l-4 border-amber-400 p-4 rounded" }, [
                      _createElementVNode("div", { class: "flex gap-3" }, [
                        _createElementVNode("svg", {
                          class: "w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          })
                        ]),
                        _createElementVNode("p", { class: "text-sm text-amber-800" }, " Esta acción no se puede deshacer. Los productos asociados a esta categoría podrían verse afectados. ")
                      ])
                    ], -1))
                  ]),
                  _createVNode(AdminModalFooter, {
                    align: "start",
                    "rounded-bottom": ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(AdminButton, {
                            variant: "secondary",
                            block: "",
                            onClick: closeDeleteModal
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode(" Cancelar ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(AdminButton, {
                            variant: "danger",
                            block: "",
                            loading: isDeleting.value,
                            onClick: confirmDelete
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(isDeleting.value ? "Eliminando…" : "Sí, eliminar"), 1)
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})